(()=>{

/* ===== EDIT HERE ===== */
// Trustpilot review count. Leave null to hide the "Based on N reviews" text.
var REVIEW_COUNT = "2,004";

// One object per card. img is relative to this file. verified:false = AI image
// (AI image: shows "Illustrative image" on the photo; pill reads Review).
var CARDS = [
  { img: "https://crepe.trymiamimd.com/cdn/shop/t/1/assets/acfbp-tf-ai-01.jpg", name: "Becky L.", verified: false,
    bullets: ["Visibly smoother-looking skin on the <b>upper arms</b>", "For <b>firmer-looking</b> skin"],
    quote: "I was skeptical as my upper underside of my arms were icky and made me extremely self conscious especially in the summer with t shirts/tank tops... Used after every shower and the results have been VERY GOOD!! and YESSSS I am pleasantly surprised.", thumbs: null, label: "ai-01" },
  { img: "https://crepe.trymiamimd.com/cdn/shop/t/1/assets/acfbp-tf-ann-t.jpg", name: "Ann T.", verified: true,
    bullets: ["Smoother-looking skin on the <b>chest and neck</b>", "For <b>firmer-looking</b> skin"],
    quote: "I wish there was a place to upload before and after pictures. I started using this in March and there's such a difference in how I look! I reordered and will continue using it. I'm soon to be 68 and I look much younger now.", thumbs: null, label: "ann-t" },
  { img: "https://crepe.trymiamimd.com/cdn/shop/t/1/assets/acfbp-tf-ai-02.jpg", name: "Kathleen L.", verified: false,
    bullets: ["For <b>firmer-looking</b> skin on the <b>neck</b>", "Visibly smoother-looking <b>neckline</b>"],
    quote: "I'm 64. Several years ago I started noticing my neck was getting saggy and 'corded'... The more I have been using this product, the better and more toned my neck looks.", thumbs: null, label: "ai-02" },
  { img: "https://crepe.trymiamimd.com/cdn/shop/t/1/assets/acfbp-tf-ai-03.jpg", name: "Amanda S.", verified: false,
    bullets: ["Visibly smoother-looking skin on the <b>arms</b>"],
    quote: "I decided to put your product on one arm and a drug store item designed for crepy skin on the other. I then started holding both arms out to my friends and asking them if they could tell a difference... They every single one get it right! That was after about two weeks.", thumbs: 43, label: "ai-03" },
  { img: "https://crepe.trymiamimd.com/cdn/shop/t/1/assets/acfbp-tf-ai-04.jpg", name: "Jodie T.", verified: false,
    bullets: ["For <b>smoother-looking</b> skin on the neck and chest"],
    quote: "I am 55 years old with normal skin... I ordered one bottle and started using it on my neck and chest... The creepiness and even my neck wrinkles reduced significantly.", thumbs: 90, label: "ai-04" },
  { img: "https://crepe.trymiamimd.com/cdn/shop/t/1/assets/acfbp-tf-ai-05.jpg", name: "Linda K.", verified: false,
    bullets: ["For <b>smoother-looking</b> skin on the <b>legs and thighs</b>"],
    quote: "My skin on my arms and upper thighs looked like toilet paper. Just so embarrassing. Now, it's much smoother and I am not embarrassed anymore.", thumbs: 35, label: "ai-05" },
  { img: "https://crepe.trymiamimd.com/cdn/shop/t/1/assets/acfbp-tf-ai-06.jpg", name: "Donna L.", verified: false,
    bullets: ["Visibly smoother-looking skin on the <b>arms</b>", "For <b>firmer-looking</b> skin on the <b>neckline</b>"],
    quote: "When I saw my arms had lost all tone and my neck was sagging I really hoped this would make a difference and it did. Big differences to my arms and I've seen substantial improvements to my neckline too.", thumbs: 95, label: "ai-06" }
];


(function(){
  var STAR = '<svg viewBox="0 0 24 24"><path fill="#fff" d="M12 2.5l2.7 6.6 7.1.5-5.4 4.6 1.7 6.9L12 17.4l-6.1 3.7 1.7-6.9L2.2 9.6l7.1-.5z"/></svg>';
  var CHECK_WHITE = '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="#fff"/><path d="M5.8 10.3l2.7 2.7 5.6-5.8" fill="none" stroke="#22b378" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHECK_GREEN = '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="#22b378"/><path d="M5.8 10.3l2.8 2.8 5.6-5.8" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var THUMB = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round" d="M7 10v11H3V10h4zm0 0l4-7c1.5 0 2.5 1 2.5 2.5V9h6a2 2 0 0 1 2 2.3l-1.3 7.5a2 2 0 0 1-2 1.7H7"/></svg>';
  var DISCLAIMER = "Based on individual user experience. Results may vary.";

  // Trustpilot stars + count
  var stars = document.getElementById("tpStars"), s = "";
  for (var i = 0; i < 5; i++) s += '<span class="acfbpx-tp-star' + (i === 4 ? ' half' : '') + '">' + STAR + '</span>';
  stars.innerHTML = s;
  if (REVIEW_COUNT !== null && REVIEW_COUNT !== undefined) {
    document.getElementById("tpNum").textContent = typeof REVIEW_COUNT === "number" ? REVIEW_COUNT.toLocaleString("en-US") : REVIEW_COUNT;
    document.getElementById("tpCount").hidden = false;
  }

  function esc(t){ return String(t).replace(/[&<>"]/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]; }); }

  var track = document.getElementById("tfTrack");
  track.innerHTML = CARDS.map(function(c){
    var bullets = (c.bullets || []).map(function(b){ return "<li>" + CHECK_GREEN + "<span>" + b + "</span></li>"; }).join("");
    var note = c.verified ? '<span class="note">' + DISCLAIMER + '</span>' : '<span class="note ai">Illustrative image</span>';
    var alt = "Before and after photo" + (c.verified ? " from " + c.name : ", illustrative");
    return '<article class="acfbpx-tf-card" data-label="' + esc(c.label || "") + '">' +
      '<div class="acfbpx-tf-photo"><img src="' + esc(c.img) + '" alt="' + esc(alt) + '" loading="lazy">' + note + '</div>' +
      '<div class="acfbpx-tf-who"><span class="acfbpx-tf-name">' + esc(c.name) + '</span>' +
        ('<span class="acfbpx-tf-pill">' + CHECK_WHITE + 'Review</span>') + '</div>' +
      '<ul class="acfbpx-tf-bullets">' + bullets + '</ul>' +
      '<p class="acfbpx-tf-quote">“' + esc(c.quote) + '”</p>' +
      (false ? '<div class="acfbpx-tf-help">' + THUMB + '<span>' + Number(c.thumbs) + '</span></div>' : '') +
    '</article>';
  }).join("");

  // Missing image -> gray placeholder box
  Array.prototype.forEach.call(track.querySelectorAll(".acfbpx-tf-photo img"), function(img){
    img.addEventListener("error", function(){
      var ph = document.createElement("div");
      ph.className = "ph"; ph.textContent = "";
      img.replaceWith(ph);
    });
  });

  // Carousel
  var section = document.querySelector(".acfbpx-tf");
  var viewport = document.getElementById("tfViewport");
  var dotsEl = document.getElementById("tfDots");
  var prev = document.getElementById("tfPrev"), next = document.getElementById("tfNext");
  var idx = 0, per = 3, positions = 1;

  function perView(){ return parseInt(getComputedStyle(section).getPropertyValue("--per"), 10) || 1; }
  function step(){
    var card = track.children[0]; if (!card) return 0;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  }
  function render(){
    track.style.transform = "translateX(" + (-idx * step()) + "px)";
    Array.prototype.forEach.call(dotsEl.children, function(d, i){
      d.classList.toggle("on", i === idx);
      d.setAttribute("aria-pressed", i === idx ? "true" : "false");
    });
  }
  function layout(){
    per = perView();
    positions = Math.max(1, CARDS.length - per + 1);
    idx = Math.min(idx, positions - 1);
    var h = "";
    for (var i = 0; i < positions; i++) h += '<button class="acfbpx-tf-dot" type="button"  aria-label="Go to position ' + (i + 1) + '"></button>';
    dotsEl.innerHTML = h;
    Array.prototype.forEach.call(dotsEl.children, function(d, i){ d.addEventListener("click", function(){ go(i); }); });
    render();
    var photo=track.querySelector('.acfbpx-tf-photo');if(photo)section.style.setProperty('--tf-arrow-y',(photo.getBoundingClientRect().top-section.getBoundingClientRect().top+photo.getBoundingClientRect().height/2)+'px');
  }
  function go(i,automatic){ if(!automatic)stopAuto(); idx = (i + positions) % positions; render(); } // arrows wrap around
  prev.addEventListener("click", function(){ go(idx - 1); });
  next.addEventListener("click", function(){ go(idx + 1); });

  // Swipe
  var timer=null,stopped=false,onScreen=false,hovered=false,motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  try{stopped=sessionStorage.getItem('acfbp-tf-manual')==='1'}catch(e){}
  function cancelAuto(){clearTimeout(timer);timer=null;}
  function stopAuto(){stopped=true;section.dataset.autoStopped='true';cancelAuto();try{sessionStorage.setItem('acfbp-tf-manual','1')}catch(e){}}
  function scheduleAuto(){cancelAuto();if(stopped||!onScreen||hovered||document.hidden||motion.matches)return;timer=setTimeout(function(){go(idx+1,true);scheduleAuto()},6000);}
  section.addEventListener('focusin',stopAuto);section.addEventListener('mouseenter',function(){hovered=true;cancelAuto()});section.addEventListener('mouseleave',function(){hovered=false;scheduleAuto()});document.addEventListener('visibilitychange',scheduleAuto);motion.addEventListener('change',scheduleAuto);
  if(window.IntersectionObserver)new IntersectionObserver(function(entries){onScreen=entries[0].isIntersecting;scheduleAuto()},{threshold:.15}).observe(section);
  viewport.addEventListener('touchstart',stopAuto,{passive:true});
  var x0 = null, y0 = null, dx = 0, dragging = false;
  viewport.addEventListener("touchstart", function(e){ x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0; dragging = false; }, {passive:true});
  viewport.addEventListener("touchmove", function(e){
    if (x0 === null) return;
    var mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
    if (!dragging && Math.abs(mx) > 8 && Math.abs(mx) > Math.abs(my)) dragging = true;
    if (dragging){
      dx = mx;
      track.style.transition = "none";
      track.style.transform = "translateX(" + (-idx * step() + dx) + "px)";
    }
  }, {passive:true});
  viewport.addEventListener("touchend", function(){
    track.style.transition = "";
    if (dragging && Math.abs(dx) > 40 && !(dx > 0 && idx === 0) && !(dx < 0 && idx === positions - 1)) go(idx + (dx < 0 ? 1 : -1)); else render();
    x0 = null; dragging = false;
  });

  var rt; window.addEventListener("resize", function(){ clearTimeout(rt); rt = setTimeout(layout, 100); });
  layout();
})();

})();